import { useCallback } from "react";

import { FormControlLabel, Typography, useTheme } from "@mui/material";
import styled from "@mui/material/styles/styled";

import useVideoStore from "@app/analytics/MeetingReport/stores/video";
import * as Events from "@app/analytics/MeetingReport/tracking/events";

import { Row, StackProps } from "@rui/Stack";
import Switch from "@rui/Switch";

const Container = styled((props: StackProps) => (
  <Row variant="center" {...props} />
))(({ theme }) => ({
  width: "100%",
  height: "32px",
  backgroundColor: theme.palette.shades.ghost[600],
  borderRadius: "0 0 8px 8px",
}));

const HighlightReelSwitch = () => {
  const theme = useTheme();
  const { highlightReel, setVideoReel, videoReel } = useVideoStore((state) => ({
    highlightReel: state.highlightReel,
    setVideoReel: state.setVideoReel,
    videoReel: state.videoReel,
  }));

  const handleToggleReel = useCallback(
    (event: React.SyntheticEvent, checked: boolean) => {
      if (!highlightReel) return;

      checked
        ? Events.playHighlightReel({ source: "switch" })
        : Events.pauseHighlightReel({ source: "switch" });
      checked
        ? setVideoReel({ ...highlightReel, playing: true })
        : setVideoReel(null);
    },
    [highlightReel]
  );

  const highlightReelIsOn = videoReel?.name === "highlights";

  return (
    <Container>
      <FormControlLabel
        control={
          <Switch
            checked={highlightReelIsOn}
            disabled={!highlightReel}
            onChange={handleToggleReel}
            disabledUncheckedColor={theme.palette.shades.neutral[100]}
            disabledUncheckedThumbColor={theme.palette.shades.neutral[300]}
            uncheckedColor={theme.palette.shades.neutral[50]}
            uncheckedThumbColor={theme.palette.shades.neutral[400]}
          />
        }
        label={
          <Typography
            variant="bodySecondaryMed"
            sx={{ color: "shades.neutral.600" }}
          >
            Play highlights only
          </Typography>
        }
      />
    </Container>
  );
};

export default HighlightReelSwitch;
